export const iconsMap = {
  billing: 'money',
  'users-admin': 'users',
};
